import { NgModule } from "@angular/core";
import { SharedModule } from "app/shared/shared.module";
import { ModalHistoryComponent } from "./modal-history.component";

@NgModule({
    imports: [SharedModule],
    declarations: [ModalHistoryComponent],
    exports: [ModalHistoryComponent],
})
export class ModalHistoryModule {}